import jsPDF from 'jspdf';
import 'jspdf-autotable';
import autoTable from 'jspdf-autotable';

const getDateRange = (fromDate, toDate) => {
    const dates = [];
    const start = new Date(fromDate);
    const end = new Date(toDate);
    const current = new Date(start);
    
    while (current <= end) {
        dates.push(new Date(current));
        current.setDate(current.getDate() + 1);
    }
    return dates;
};


const getDayShort = (date) => {
    const days = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
    return days[date.getDay()];
};


const formatDateHeader = (date) => {
    const d = new Date(date);
    const day = String(d.getDate()).padStart(2, '0');
    const month = d.toLocaleString('en', { month: 'short' });
    const year = String(d.getFullYear()).slice(-2);
    return `${day}-${month}-${year}`;
};


const formatDate = (date) => {
    const d = new Date(date);
    const year = d.getFullYear();
    const month = String(d.getMonth() + 1).padStart(2, '0');
    const day = String(d.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
};


const formatDateRow = (date) => {
    const d = new Date(date);
    const day = String(d.getDate()).padStart(2, '0');
    const month = d.toLocaleString('en', { month: 'short' });
    const year = String(d.getFullYear()).slice(-2);
    const dayName = getDayShort(date);
    return `${dayName} ${day}-${month}-${year}`;
};


export const generateAndDownloadCalendarPDF = ({
    rowData,
    fromDate,
    toDate,
    propertyName,
    shiftName,
    selectedYojnas,
    yojnaData,
    fileName = 'Task_Calendar_Report.pdf'
}) => {
    try {
        
        const doc = new jsPDF('landscape', 'mm', 'a2');
        const pageWidth = doc.internal.pageSize.width;
        const pageHeight = doc.internal.pageSize.height;
        
      
        const dateRange = getDateRange(fromDate, toDate);
        
       
        const workstations = [...new Set(rowData.map(item => item.HkWrkStnName))].filter(Boolean);
        const tasks = [...new Set(rowData.map(item => item.HkTaskName))].filter(Boolean);
        
        
        const taskMatrix = {};
        workstations.forEach(ws => {
            taskMatrix[ws] = tasks.filter(task => 
                rowData.some(item => item.HkWrkStnName === ws && item.HkTaskName === task)
            );
        });
        
      
        doc.setFontSize(16);
        doc.setFont('helvetica', 'bold');
        doc.text('TASK CALENDAR REPORT', pageWidth / 2, 15, { align: 'center' });
        
     
        doc.setFontSize(10);
        doc.setFont('helvetica', 'normal');
        const yojnaNames = selectedYojnas && selectedYojnas.length > 0 
            ? selectedYojnas.map(id => {
                const yojna = yojnaData?.find(y => y.id.toString() === id.toString());
                return yojna?.name || id;
            }).join(', ')
            : 'All Yojnas';
        
        doc.text(`Property: ${propertyName}  |  Shift: ${shiftName}  |  Yojna: ${yojnaNames}`, pageWidth / 2, 22, { align: 'center' });
        doc.text(`Date Range: ${formatDateHeader(new Date(fromDate))} to ${formatDateHeader(new Date(toDate))}`, pageWidth / 2, 29, { align: 'center' });
        
       
        let yPosition = 38;
        
    
        workstations.forEach((workstation, wsIndex) => {
            const workstationTasks = taskMatrix[workstation] || [];
            
            if (workstationTasks.length === 0) return;
            
           
            if (yPosition > pageHeight - 50) {
                doc.addPage();
                yPosition = 20;
            }
            
         
            doc.setFillColor(99, 91, 255);
            doc.rect(14, yPosition - 3, pageWidth - 28, 8, 'F');
            doc.setFontSize(10);
            doc.setFont('helvetica', 'bold');
            doc.setTextColor(255, 255, 255);
            doc.text(`WORKSTATION: ${workstation}`, 18, yPosition + 2);
            yPosition += 8;
            doc.setTextColor(0, 0, 0);
            
         
            const headers = ['Date'];
            workstationTasks.forEach(task => {
                headers.push(task);
            });
            
         
            const rows = [];
            dateRange.forEach((date, dateIndex) => {
                const row = [
                    formatDateRow(date) 
                ];
                
                const dateStr = formatDate(date);
                const dayShort = getDayShort(date);
                
                workstationTasks.forEach(task => {
                  
                    const isActive = rowData.some(item => 
                        item.HkWrkStnName === workstation && 
                        item.HkTaskName === task && 
                        (item[dayShort] === "1" || item[`${dayShort}A`] === "1")
                    );
                    row.push(isActive ? 'Yes' : 'No');
                });
                
                rows.push(row);
            });
          
            const totalColumns = headers.length;
            const availableWidth = pageWidth - 28;
            const dateColWidth = 35; 
            const taskColWidth = (availableWidth - dateColWidth) / (totalColumns - 1);
            
            
            autoTable(doc, {
                head: [headers],
                body: rows,
                startY: yPosition,
                theme: 'grid',
                styles: {
                    fontSize: 6,
                    cellPadding: 1.5,
                    lineColor: [180, 180, 180],
                    lineWidth: 0.1,
                    valign: 'middle',
                },
                headStyles: {
                    fillColor: [52, 58, 64],
                    textColor: [255, 255, 255],
                    fontSize: 6,
                    fontStyle: 'bold',
                    halign: 'center',
                    valign: 'middle',
                    lineColor: [52, 58, 64],
                },
                columnStyles: {
                    0: { cellWidth: dateColWidth, halign: 'center' },
                },
                didParseCell: function(data) {
                    const { column, cell, row, section } = data;
                    
                  
                    if (section === 'head' && column.index > 0) {
                        cell.styles = {
                            ...cell.styles,
                            fontSize: 5,
                            halign: 'center',
                            valign: 'middle',
                            lineColor: [52, 58, 64],
                        };
                   
                        if (cell.raw && cell.raw.length > 20) {
                            cell.text = cell.raw.substring(0, 18) + '...';
                        }
                    }
                    
                 
                    if (section === 'body' && column.index === 0) {
                        cell.styles = {
                            ...cell.styles,
                            fillColor: [240, 240, 240],
                            halign: 'center',
                            valign: 'middle',
                            fontSize: 6,
                            fontStyle: 'bold',
                        };
                    }
                    
                    
                    if (section === 'body' && column.index > 0 && row.raw) {
                        const value = cell.raw;
                     
                        if (value === 'Yes' || value === true) {
                          
                            const dateStr = rows[row.index]?.[0] || '';
                            cell.styles = {
                                ...cell.styles,
                                fillColor: [76, 175, 80],
                                textColor: [255, 255, 255],
                                halign: 'center',
                                valign: 'middle',
                                fontSize: 8,
                            };
                            cell.text = '✓';
                        } else {
                            cell.styles = {
                                ...cell.styles,
                                fillColor: [255, 255, 255],
                                textColor: [200, 200, 200],
                                halign: 'center',
                                valign: 'middle',
                            };
                            cell.text = '';
                        }
                    }
                },
                margin: { left: 14, right: 14 },
                tableWidth: pageWidth - 28,
                rowPageBreak: 'avoid',
            });
            
            
            const lastTable = doc.lastAutoTable;
            yPosition = lastTable.finalY + 8;
            
           
            if (wsIndex < workstations.length - 1) {
                doc.setDrawColor(200, 200, 200);
                doc.setLineWidth(0.5);
                doc.line(14, yPosition - 2, pageWidth - 14, yPosition - 2);
                yPosition += 4;
            }
        });
        
       
        const totalPages = doc.internal.getNumberOfPages();
        for (let i = 1; i <= totalPages; i++) {
            doc.setPage(i);
            doc.setFontSize(7);
            doc.setFont('helvetica', 'normal');
            doc.setTextColor(150, 150, 150);
            doc.text(
                `Generated on: ${new Date().toLocaleString()} | Page ${i} of ${totalPages}`,
                pageWidth / 2,
                pageHeight - 8,
                { align: 'center' }
            );
        }
       
        doc.save(fileName);
        
        return true;
    } catch (error) {
        console.error('Error generating calendar PDF:', error);
        throw error;
    }
};

export default generateAndDownloadCalendarPDF;